var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "esign-settings-providers" },
    [
      _c("span", { staticClass: "mb-4 fs-5 bold" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Service de signature électronique")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "semibold mb-2 fs-3 lh-20" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Faites signer vos documents plus vite et de manière sécurisée"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "mb-4" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Vos destinataires reçoivent votre signature et peuvent apposer leur signature en seulement quelques secondes. Obtenir la signature de documents PDF n’a jamais été aussi simple !"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "provider-choices flex-row ai-center jc-space" },
        [
          _c(
            "div",
            { staticClass: "flex-row provider-informations" },
            [
              _c(
                "icon-svg",
                {
                  staticClass: "ml-3 provider-icon",
                  attrs: { height: 32, width: 32, viewBox: "0 0 40 40" }
                },
                [
                  _vm.providerSelected.name
                    ? _c("Icon" + _vm.providerSelected.name, {
                        tag: "component"
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "semibold fs-3 gray-100 lh-20" }, [
                _vm._v(_vm._s(_vm.providerSelected.name))
              ]),
              _vm._v(" "),
              _vm.isProviderSellsy
                ? _c("tag-rounded", {
                    staticClass: "semibold my-3 py-1",
                    attrs: {
                      label: _vm.$t.__("common.labels.by_default"),
                      radius: 44,
                      bgcolor: "secondary-grey",
                      color: "gray-60 "
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isProviderSellsy
                ? _c("chip-label", {
                    ref: "chip-label-status-provider",
                    attrs: {
                      color: _vm.colorLabelStatusDocusign,
                      label: _vm.labelStatusDocusign
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fright flex-row ai-center" },
            [
              !_vm.isProviderSellsy && _vm.isConnected
                ? _c(
                    "link-button",
                    {
                      staticClass: "mr-5 btn-check-status",
                      on: { clicked: _vm.onCheckStatus }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$l10n.__("Actualiser le statut")) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isProviderSellsy
                ? _c("CompassButton", {
                    ref: "submitBtn",
                    staticClass: "mr-3",
                    attrs: {
                      label: _vm.labelSubmitBtn,
                      type: _vm.bkgSubmitBtn,
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        return _vm.onLoginProvider()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isConnected
                ? _c("CompassButton", {
                    ref: "changeProviderBtn",
                    staticClass: "mr-3",
                    attrs: {
                      label: _vm.$t.__(
                        "esign.ESignSettingsProviders.edit_service"
                      ),
                      size: "small",
                      type: "primary"
                    },
                    on: { click: _vm.onModifProvider }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }